import * as React from "react";
import { Link } from "react-router-dom";
import { GeneralContext } from "@services/providers/GeneralProvider";

interface MapWheelPrope {
  onClose: () => void;
}

const MapWheel: React.FC<MapWheelPrope> = ({ onClose }) => {
  const [wheelVisible, setWheelVisible] = React.useState(false);
  const { productType, permissions } = React.useContext(GeneralContext);
  const scale = window.innerWidth / 1920;

  React.useEffect(() => {
    setWheelVisible(true);
  }, []);

  let wheelData: {
    x: number;
    y: number;
    url: string;
    name: string;
    class: string;
    newTab?: boolean;
    oldPage?: boolean;
    permission_code: string;
    style?: React.CSSProperties;
  }[] = [];

  function closeWheel() {
    setWheelVisible(false);
    setTimeout(() => {
      onClose();
    }, 500);
  }

  let wheelImageUrl = "";
  let wheelGlobeLink = "";

  switch (productType) {
    case "ndr":
      wheelImageUrl = process.env.STATIC_PATH + "/images/wheel-new/wheel.png";
      wheelGlobeLink = "/custom-dashboard/liveshadow";
      wheelData = [
        {
          x: 164,
          y: 74,
          url: "/shadow360",
          name: "Shadow 360",
          class: "-translate-x-full -translate-y-2/4 text-right text-white",
          newTab: true,
          permission_code: "can_access_shadow360",
          style: { marginLeft: `${-60 * scale}px` },
        },
        {
          x: 78,
          y: 172,
          url: "/ai-engine/",
          name: "AI-Powered Engine",
          class: "-translate-x-full -translate-y-2/4 text-right text-white",
          permission_code: "can_access_ai_engine",
          style: { marginLeft: `${-60 * scale}px` },
        },
        {
          x: 49,
          y: 302,
          url: "/aml-anomaly-detection",
          name: "AML Anomaly Detection",
          class: "-translate-x-full -translate-y-2/4 text-right text-white",
          permission_code: "can_access_threatshadow",
          style: { marginLeft: `${-60 * scale}px` },
        },
        {
          x: 176,
          y: 503,
          url: "/asset-autodiscovery",
          name: "Asset Autodiscovery",
          class: "-translate-x-full -translate-y-2/4 text-right text-white",
          permission_code: "can_access_assetAutoDiscovery",
          style: { marginLeft: `${-60 * scale}px` },
        },
        {
          x: 303,
          y: 537,
          url: "/identity-intelligence",
          name: "Identity Intelligence",
          class: "translate-y-full -translate-x-2/4 text-center text-white",
          permission_code: "can_access_identityIntelligence",
          style: { marginTop: `${25 * scale}px` },
        },
        {
          x: 430,
          y: 502,
          url: "/threatscore-quadrant",
          name: "ThreatScore Quadrant",
          class: "translate-x-full -translate-y-2/4 text-left text-white",
          permission_code: "can_access_threatScoreQuadrant",
          style: { marginLeft: `${-50 * scale}px` },
        },
        {
          x: 551,
          y: 303,
          url: "/custom-dashboard/liveshadow",
          name: "LiveShadow",
          class: "translate-x-full -translate-y-2/4 text-left text-white",
          permission_code: "can_access_liveshadow",
          style: { marginLeft: `${-50 * scale}px` },
        },
        {
          x: 527,
          y: 175,
          url: "/management-dashboard",
          name: "Management Dashboard",
          class: "translate-x-full -translate-y-2/4 text-left text-white",
          permission_code: "can_access_managementDashboard",
          style: { marginLeft: `${-50 * scale}px` },
        },
        {
          x: 439,
          y: 77,
          url: "/blockcount-ratio",
          name: "Block Count Ratio",
          class: "translate-x-full -translate-y-2/4 text-left text-white",
          permission_code: "can_access_blockCountRatio",
          style: { marginLeft: `${-50 * scale}px` },
        },
      ];
      break;
    case "ddr":
      wheelImageUrl = process.env.STATIC_PATH + "/images/ddr/ls-wheel.png";
      wheelGlobeLink = "/security-posture";
      wheelData = [
        {
          x: 165,
          y: 76,
          url: "/ai-engine/",
          name: "AI-Powered Engine",
          class: "-translate-x-full -translate-y-2/4 text-right text-white",
          permission_code: "can_access_ai_engine",
          style: { marginLeft: `${-60 * scale}px` },
        },
        {
          x: 76,
          y: 174,
          url: "/security-posture",
          name: "Security Posture",
          class: "-translate-x-full -translate-y-2/4 text-right text-white",
          oldPage: true,
          permission_code: "",
          style: { marginLeft: `${-60 * scale}px` },
        },
        {
          x: 50,
          y: 302,
          url: "/risk-compliance",
          name: "Risk & Compliance",
          class: "-translate-x-full -translate-y-2/4 text-right text-white",
          permission_code: "can_access_risk_compliance",
          style: { marginLeft: `${-60 * scale}px` },
        },
        {
          x: 176,
          y: 501,
          url: "/shadow360",
          name: "Shadow 360",
          class: "-translate-x-full -translate-y-2/4 text-right text-white",
          permission_code: "can_access_shadow360",
          style: { marginLeft: `${-60 * scale}px` },
        },
        {
          x: 301,
          y: 536,
          url: "/data-exposure",
          name: "Data Exposure",
          class:
            "translate-y-full mt-[25px] -translate-x-2/4 text-center text-white",
          permission_code: "can_access_data_exposure",
          style: { marginTop: `${25 * scale}px` },
        },
        {
          x: 428,
          y: 500,
          url: "/identity-intelligence",
          name: "Identity Intelligence",
          class: "translate-x-full -translate-y-2/4 text-left text-white",
          permission_code: "can_access_identityIntelligence",
          style: { marginLeft: `${-50 * scale}px` },
        },
        {
          x: 548,
          y: 303,
          url: "/data-sovereignty",
          name: "Data Sovereignty",
          class: "translate-x-full -translate-y-2/4 text-left text-white",
          permission_code: "can_access_dataSovereignty",
          style: { marginLeft: `${-50 * scale}px` },
        },
        {
          x: 524,
          y: 177,
          url: "/sensitive-data",
          name: "Sensitive Data",
          class: "translate-x-full -translate-y-2/4 text-left text-white",
          permission_code: "can_access_sensitive_data",
          style: { marginLeft: `${-50 * scale}px` },
        },
        {
          x: 437,
          y: 79,
          url: "/data-inventory",
          name: "Data Inventory",
          class: "translate-x-full -translate-y-2/4 text-left text-white",
          permission_code: "can_access_data_inventory",
          style: { marginLeft: `${-50 * scale}px` },
        },
      ];
      break;
    case "itdr":
      wheelImageUrl = process.env.STATIC_PATH + "/images/itdr/itdr-wheel.png";
      wheelGlobeLink = "/identity-posture";
      wheelData = [
        {
          x: 165,
          y: 76,
          url: `${"/risk-remediation/"}`,
          name: `${"Risk Remediation"}`,
          class: "-translate-x-full -translate-y-2/4 text-right text-white",
          permission_code: "can_access_risk_remediation",
          style: { marginLeft: `${-60 * scale}px` },
        },
        {
          x: 76,
          y: 174,
          url: `${"/identity-posture/"}`,
          name: `${"Identity Posture"}`,
          class: "-translate-x-full -translate-y-2/4 text-right text-white",
          oldPage: true,
          permission_code: "",
          style: { marginLeft: `${-60 * scale}px` },
        },
        {
          x: 50,
          y: 302,
          url: "/ai-engine/",
          name: `${"AI Powered Engine"}`,
          class: "-translate-x-full -translate-y-2/4 text-right text-white",
          permission_code: "can_access_ai_engine",
          style: { marginLeft: `${-60 * scale}px` },
        },
        {
          x: 176,
          y: 501,
          url: `${"/behavior-analytics/"}`,
          name: `${"Behavior Analytics"}`,
          class: "-translate-x-full -translate-y-2/4 text-right text-white",
          permission_code: "can_access_behavior_analytics",
          style: { marginLeft: `${-60 * scale}px` },
        },
        {
          x: 301,
          y: 536,
          url: `${"/shadow360"}`,
          name: `${"Shadow 360"}`,
          class: "translate-y-full -translate-x-2/4 text-center text-white",
          permission_code: "can_access_shadow360",
          style: { marginTop: `${25 * scale}px` },
        },
        {
          x: 428,
          y: 500,
          url: `${"/aml-anomaly-detection/"}`,
          name: `${"AML Anomaly Detection"}`,
          class: "translate-x-full -translate-y-2/4 text-left text-white",
          permission_code: "can_access_aml_anomaly_detection",
          style: { marginLeft: `${-50 * scale}px` },
        },
        {
          x: 548,
          y: 303,
          url: `${"/identity-intelligence/"}`,
          name: `${"Identity Intelligence"}`,
          class: "translate-x-full -translate-y-2/4 text-left text-white",
          permission_code: "can_access_identityIntelligence",
          style: { marginLeft: `${-50 * scale}px` },
        },
        {
          x: 524,
          y: 177,
          url: `${"/continuous-monitoring/"}`,
          name: `${"Continuous Monitoring"}`,
          class: "translate-x-full -translate-y-2/4 text-left text-white",
          permission_code: "can_access_continuous_monitoring",
          style: { marginLeft: `${-50 * scale}px` },
        },
        {
          x: 437,
          y: 79,
          url: `${"/user-directory/"}`,
          name: `${"User Directory"}`,
          class: "translate-x-full -translate-y-2/4 text-left text-white",
          permission_code: "can_access_user_directory",
          style: { marginLeft: `${-50 * scale}px` },
        },
      ];
      break;
    default:
      wheelImageUrl = process.env.STATIC_PATH + "/images/wheel-new/wheel.png";
      wheelGlobeLink = "/custom-dashboard/liveshadow";
  }

  return (
    <>
      <div
        className={
          "transition-all duration-500 z-modal-level-3 relative " +
          (wheelVisible
            ? "opacity-1 pointer-events-auto"
            : "opacity-0 pointer-events-none")
        }
      >
        <div
          className="w-full h-[100vw] -translate-y-[25vw] fixed top-0 left-0 z-modal-level-3 bg-[radial-gradient(black_25%,#00000057_100%)] bg-center bg-cover"
          onClick={closeWheel}
        ></div>
        <div
          style={{ width: 600 * scale + "px", height: 600 * scale + "px" }}
          className="fixed left-2/4 top-2/4 z-modal-level-3 -translate-x-2/4 -translate-y-2/4"
        >
          <img
            src={wheelImageUrl}
            className="w-full h-full object-contain"
            alt=""
          />
          {/* <Link to={wheelGlobeLink} reloadDocument={true} target="">
          </Link> */}
          {Array.from({ length: 6 }).map((_, index) => (
            <div
              key={index + "ring"}
              className={
                "absolute top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4 border-dashed border-gray-500 rounded-full animate-ring border pointer-events-none"
              }
              style={{
                height: 100 + index * 18 + "%",
                width: 100 + index * 18 + "%",
                opacity: 0,
                animationDelay: 1000 + index * 150 + "ms",
              }}
            ></div>
          ))}

          {/* Hover Effect */}
          <div>
            {wheelData.map((data, index) => {
              if (
                permissions.includes(data.permission_code) == false &&
                data.permission_code
              )
                return;
              return (
                <Link
                  key={index}
                  to={data.url}
                  reloadDocument={data.oldPage}
                  target={data.newTab ? "_blank" : undefined}
                  onClick={() => closeWheel()}
                >
                  <div
                    style={{
                      top: data.y * scale + "px",
                      left: data.x * scale + "px",
                      width: 80 * scale + "px",
                      height: 80 * scale + "px",
                      transform: `translate(-50%, -50%)`,
                    }}
                    className="absolute"
                  >
                    <div
                      key={index + "area"}
                      style={{ animationDelay: index * 100 + "ms" }}
                      className={`z-level-3 cursor-pointer rounded-full animate-mapAreaAnim transition-all hover:shadow-[0px_0px_20px_rgb(255,255,255)] w-full h-full`}
                    ></div>
                  </div>
                </Link>
              );
            })}

            {wheelData.map((data, index) => (
              <div
                style={{
                  ...(data.style || {}),
                  top: data.y * scale + "px",
                  left: data.x * scale + "px",
                  width: 110 * scale + "px",
                  animationDelay: index * 100 + "ms",
                }}
                className={
                  "absolute " +
                  data.class +
                  " " +
                  (permissions.includes(data.permission_code) == false &&
                  data.permission_code
                    ? "!opacity-20"
                    : "")
                }
                key={index + "name"}
              >
                {data.name}
              </div>
            ))}

            {wheelData.map((data, index) => {
              if (
                permissions.includes(data.permission_code) ||
                !data.permission_code
              )
                return;
              return (
                <div
                  key={index}
                  style={{
                    top: data.y * scale + "px",
                    left: data.x * scale + "px",
                    width: 80 * scale + "px",
                    height: 80 * scale + "px",
                  }}
                  className="absolute"
                >
                  <div
                    key={index + "area"}
                    className={`z-level-4 bg-black opacity-80 rounded-full -translate-x-2/4 -translate-y-2/4`}
                  ></div>
                </div>
              );
            })}
          </div>
        </div>
        <Link to={wheelGlobeLink} reloadDocument={true} target="">
          <img
            src={
              process.env.STATIC_PATH + "/images/wheel-new/globe_animation.gif"
            }
            className="w-[16vw] h-[16vw] object-contain fixed top-2/4 -mt-3 -translate-y-2/4 left-2/4 -translate-x-2/4 z-modal-level-3 rounded-full globeGif"
            alt=""
          />
        </Link>
      </div>
    </>
  );
};

export default MapWheel;
